import React from 'react';
import moment from 'moment';

export type PlanTermWorkingTimeProps = {
  id?: number | null,
  planTermWorkingTimeId?: number | null,
  startTime?: string,
  endTime?: string,
  workingTime?: string,
  startTimeText?: string,
  endTimeText?: string,
  workingTimeText?: string,
};

export type PlanTermProps = {
  id?: number | null,
  planId?: number | null,
  planTermId?: number | null,
  startDate?: moment.MomentInput,
  endDate?: moment.MomentInput,
  startTime?: moment.MomentInput,
  endTime?: moment.MomentInput,
  hasOvertimeWork: boolean,
  meetingPlace?: string | null,
  meetingTime?: moment.MomentInput,
  isFreeMeeting?: boolean,
  firstDayStatus?: 'scheduled' | 'moving' | null,
  dismissalPlace?: string | null,
  dismissalTime?: moment.MomentInput,
  isFreeDismissal?: boolean,
  lastDayStatus?: 'scheduled' | 'moving' | null,
  hourlyWage?: number | null,
  holidays?: number | null,
  isOpen?: boolean,
  number?: number | null,
  totalApplicantsCount?: number,
  applicantsCount?: number,
  activeApplicantsCount?: number,
  isAccepting?: boolean,
  isFutureOpen?: boolean,
  isFinished?: boolean,
  totalWages?: number,
  totalAmount?: number,
  increaseAllowed?: boolean,
  deleteAllowed?: boolean,
  totalTimes?: moment.MomentInput,
  workingTimes?: Array<PlanTermWorkingTimeProps>,
  startTimeText?: string | null,
  endTimeText?: string | null,
  totalTimesText?: string | null,
  isRegistWorkingTime: boolean,
  remainingNumber?: number,
};

export type PlanProps = {
  id?: number | null,
  title?: string | null,
  content?: string | null,
  accommodation?: string | null,
  amenity?: string | null,
  benefit?: string | null,
  belonging?: string | null,
  notes?: string | null,
  comment?: string | null,
  publishedAt?: string | null,
  isPublic?: boolean,
  terms?: Array<PlanTermProps>,
};

type SetPlanProp = React.SetStateAction<PlanProps>;

type PlanComponent = {
  holiday?: React.ComponentType,
  money?: React.ComponentType,
};

type PlanContextProps = {
  plan: PlanProps,
  setPlan: (data: SetPlanProp) => void,
  isReview?: boolean,
  readOnly?: boolean,
  loaded?: boolean,
  version: number,
  incrementVersion: () => void,
  component?: PlanComponent,
};

const PlanContext: React.Context<PlanContextProps> = React.createContext({
  plan: {},
  setPlan: (data: SetPlanProp) => {},
  isReview: false,
  readOnly: false,
  loaded: false,
  version: 0,
  incrementVersion: () => {},
  component: {},
});

export default PlanContext;
